import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import arrowLeft from '../../../assets/image/arrowleft.png';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';

interface TaskGradingTopHeaderProps {
  title: string;
}

function TaskGradeEditHeader({ title }: TaskGradingTopHeaderProps) {
  const navigate = useNavigate();
  const { isMobile, isOutlook } = useMediaQueryState();
  const handleClickArrowBtn = () => {
    navigate(-1);
  };

  return (
    <>
      <Grid container justifyContent={'space-around'} style={{ marginTop: '46px' }}>
        <Grid sx={{ marginTop: isOutlook ? '-20px' : '0px', cursor: 'pointer' }}>{isMobile && <img src={arrowLeft} onClick={handleClickArrowBtn} alt='backIcon' />}</Grid>
        <Grid
          width='250px'
          textAlign={'center'}
          style={{
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '18px',
          }}
        >
          {title}
        </Grid>
        <Grid marginTop={2}></Grid>
      </Grid>
    </>
  );
}

export default observer(TaskGradeEditHeader);
